import * as types from './constants';

// Get Shopify Collection Variant Counts
export const getShopifyCollectionVariantCountsRequest = data => (
  { type: types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_REQUEST, payload: data }
);

export const getShopifyCollectionVariantCountsDone = data => (
  { type: types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_DONE, payload: data }
);

export const getShopifyCollectionVariantCountsFailed = errors => (
  { type: types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_FAILED, payload: errors }
);

export const getShopifyCollectionVariantCountsReset = () => (
  { type: types.GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_RESET }
);
